/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Stack, Box, Button} from '@salesforce/retail-react-app/app/components/shared/ui'
import Field from '../../components/field'
import useLoginFields from '../../components/forms/useLoginFields'

const LoginFields = ({
    form,
    handleForgotPasswordClick,
    prefix = '',
    hideEmail = false,
    hidePassword = false,
    isLoginPage = false
}) => {
    const fields = useLoginFields({form, prefix})
    return (
        <Stack spacing={5}>
            {!hideEmail && <Field {...fields.email} isLoginPage={isLoginPage} />}
            {!hidePassword && (
                <Stack gap={0}>
                    <Field {...fields.password} isLoginPage={isLoginPage} />
                    {handleForgotPasswordClick && (
                        <Box textAlign="right">
                            <Button
                                variant="link"
                                onClick={handleForgotPasswordClick}
                                fontSize="xs"
                                lineHeight="15px"
                                textDecoration="underline"
                                mt="16.5px"
                            >
                                <FormattedMessage
                                    defaultMessage="Forgot password?"
                                    id="contact_info.link.forgot_password"
                                />
                            </Button>
                        </Box>
                    )}
                </Stack>
            )}
        </Stack>
    )
}

LoginFields.propTypes = {
    handleForgotPasswordClick: PropTypes.func,

    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string,

    /** Optional configurations */
    hideEmail: PropTypes.bool,
    hidePassword: PropTypes.bool,

    isLoginPage: PropTypes.bool
}

export default LoginFields
